import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEmitirFacturaReq } from '@core/interfaces/request-response/facturacion.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class FacturacionApiService extends BaseHttpService {
  emitir(req: IEmitirFacturaReq) {
    return this.withLoader(
      this.httpClient.post(`${environment.apiFacturacionUrl}${environment.apiPreFix}/facturacion/emitir`, req),
    );
  }

  listar(pagina: number = 1, size: number = 50) {
    const params = new HttpParams().set('pagina', pagina).set('size', size);
    return this.httpClient.get(`${environment.apiFacturacionUrl}${environment.apiPreFix}/facturacion/listar`, {
      params,
    });
  }

  anular(id: number, motivo: string) {
    return this.httpClient.post(
      `${environment.apiFacturacionUrl}${environment.apiPreFix}/facturacion/anular/${id}`,
      { motivo },
    );
  }

  reemitir(id: number) {
    return this.withLoader(
      this.httpClient.post(`${environment.apiFacturacionUrl}${environment.apiPreFix}/facturacion/reemitir/${id}`, {}),
    );
  }
}
